module.exports = __webpack_public_path__ + "public/images/curve-shadow.469e824e6bf557503e11abe2b3f3d1a2.svg";